<template>
  <div class="t-structure-body innerbox">
    <div class="t-team-head">
      <div class="t-team-head-tit">
        团队长架构图
      </div>
      <div>
        <el-button type="success" @click="treeStyle = '0'" icon="el-icon-circle-plus-outline" size="mini" plain>原图</el-button>
        <el-button type="success" @click="treeStyle = '1'" icon="el-icon-remove-outline" size="mini" plain>缩小</el-button>
      </div>
      <div>
        <el-button type="primary" @click="toPage" icon="el-icon-arrow-left" size="mini" plain>返回</el-button>
      </div>
    </div>
    <TeamTree v-if="list.length > 0" :listData="list" :textStyle="treeStyle" :dataIndex="1"></TeamTree>
  </div>
</template>

<script>
import TeamTree from '@/components/public/TeamTree.vue'
export default {
  name: 'salesmanStructure',
  components: {
    TeamTree
  },
  data () {
    return {
      isLoading: false,
      userType: '',
      cooperatorId: '',
      treeStyle: '0',
      teamId: '',
      salesmanPageNo: 1,
      list: []
    }
  },
  methods: {
    toPage () {
      this.$router.push({path: '/salesman/salesman'})
    },
    loadData () {
      let _this = this
      _this.isLoading = true
      let param = {
        userType: _this.userType,
        cooperatorId: _this.cooperatorId
      }
      this.$axios.post('/salesmanStructure/list', param)
        .then((res) => {
          if (res.status === 200) {
            _this.list = res.data
          } else {
            _this.$message.error('加载失败')
          }
          _this.isLoading = false
        })
    }
  },
  mounted () {
    if (!window.sessionStorage.user) {
      return this.$router.push({name: 'login'})
    } else {
      this.userType = JSON.parse(window.sessionStorage.user).userType
    }
    if (this.userType === '1') {
      this.cooperatorId = this.$route.query.cooperatorId
    }
    this.loadData()
  }
}
</script>

<style scoped>
.t-structure-body {
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 15px;
  box-sizing: border-box;
  overflow: auto;
  display: block;
}

/*// 滚动条整体样式*/
.innerbox::-webkit-scrollbar{
  width: 15px;
  height: 15px;
}
/*// 滚动条内嵌滑块*/
.innerbox::-webkit-scrollbar-thumb{
 border-radius: 10px;
 background: rgba(0,0,0,0.3);
 box-shadow: inset 0 0 5px rgba(0,0,0,0.3);
 -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.3);
}
/*// 滚动条边角*/
.innerbox::-webkit-scrollbar-corner{
 border-radius: 0;
 background: rgba(0,0,0,0.3);
 box-shadow: inset 0 0 5px rgba(0,0,0,0.3);
 -webkit-box-shadow:inset 0 0 5px rgba(0,0,0,0.3);
}

.t-team-head {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
}

.t-team-head-tit {
  font-size: 24px;
  color: #333333;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/salesman/SalesmanStructure.vue